import { render, staticRenderFns } from "./NotImplementedYet.vue?vue&type=template&id=0bfdcc47&"
import script from "./NotImplementedYet.vue?vue&type=script&lang=js&"
export * from "./NotImplementedYet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports